<template>
  <div>
    <v-card-title>
      <b>Leads</b>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="leads"
      :search="search"
      class="elevation-1"
      select-all
      :loading="loading"
      no-data-text="Não há leads cadastrados"
      rows-per-page-text="Linhas por página"
      :pagination.sync="pagination"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
            ></v-checkbox>
          </td>
          <td>{{ props.item.item.created_at | formatarData }}</td>
          <td>{{ props.item.item.name }}</td>
          <td class="text-xs-right">{{ props.item.item.email }}</td>
          <td class="text-xs-right">{{ props.item.item.phone }}</td>
          <td class="text-xs-right">{{ props.item.item.step }}</td>
          <td class="text-xs-right">
            <img
              src="@/assets/icons/bill.png"
              alt="conta"
              v-if="props.item.item.bills"
              @click="selectBills(props.item.item.bills)"
            />
          </td>
          <td>
            <v-icon @click="editLead(props.item.item)">visibility</v-icon>
          </td>
        </tr>
      </template>

      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Sua busca para "{{ search }}" não retornou resultados.
      </v-alert>
      <template v-slot:pageText="props">
        Linhas {{ props.pageStart }} - {{ props.pageStop }} de
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          CONTA DE ENERGIA
        </v-card-title>

        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex v-for="bill in selectedBills" :key="bill.url" xs4 d-flex>
              <v-card flat tile class="d-flex">
                <v-img
                  :src="bill.url"
                  :lazy-src="bill.url"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_lead"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <!--
        <v-toolbar color="success">
            <v-btn icon dark @click="dialog_lead = false">
            <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Editar Lead</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        -->
        <v-card-text>
          <Lead :mylead="lead"></Lead>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Lead from "@/components/Lead.vue";
import moment from "moment";
import { getLeads } from "../services/leads";

export default {
  name: "Leads",
  components: {
    Lead,
  },
  data() {
    return {
      search: "",
      selected: [],
      selectEmail: "",
      dialog: false,
      dialog_lead: false,
      loading: false,
      pagination: {
        sortBy: "item.created_at",
        rowsPerPage: 10,
      },
      headers: [
        {
          text: "Data de Criação",
          align: "left",
          value: "item.created_at",
        },
        {
          text: "Nome",
          align: "left",
          value: "item.name",
        },
        { text: "E-mail", value: "item.email" },
        { text: "Telefone", value: "item.phone" },
        { text: "Passo", sortable: false },
        { text: "", sortable: false, name: "contas" },
        { text: " ", sortable: false, name: "edit" },
      ],
      leads: [],
      lead: "",
      selectedBills: [],
    };
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.leads.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async fetchLeads() {
      this.loading = true;
      getLeads()
        .then((result) => {
          if (result.data) {
            this.leads = result.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.error("Error: ", err);
          this.loading = false;
        });
    },
    selectBills(bills) {
      this.selectedBills = bills;
      // console.log('selectedBills: ', this.selectedBills)
      this.dialog = true;
    },
    editLead(lead) {
      // console.log(lead)
      this.dialog_lead = true;
      this.lead = lead;
    },
  },
  mounted() {
    this.fetchLeads();
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      // console.log(value)
      // value = value.toString()
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object

      // console.log(myDate)
      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
    formatStep: function (value) {
      var step_text = "";
      if (!value) return "";

      if (value === "0") {
        step_text = "Sem contas";
      } else if (value === "1") {
        step_text = "Gerando propostas";
      } else {
        step_text = "error";
      }
      return step_text;
    },
  },
};
</script>
<style scope></style>
